import React from 'react';
import { IconFlag } from 'design-system/icons';
import IconBoldQuestion from 'design-system/icons/IconBoldQuestion';
import { IconCategory } from 'design-system/icons/IconCategory';
import IconEyes from 'design-system/icons/IconEyes';
import { IconHeartCrackSolid } from 'design-system/icons/IconHeartCrackSolid';
import { IconPiggyBank } from 'design-system/icons/IconPiggyBank';
import { IconSettings } from 'design-system/icons/IconSettings';
export var DeleteReasonID;
(function (DeleteReasonID) {
    DeleteReasonID[DeleteReasonID["AppBroken"] = 0] = "AppBroken";
    DeleteReasonID[DeleteReasonID["DontKnowHowToUse"] = 1] = "DontKnowHowToUse";
    DeleteReasonID[DeleteReasonID["ItsNotWorking"] = 2] = "ItsNotWorking";
    DeleteReasonID[DeleteReasonID["UseAnotherApp"] = 3] = "UseAnotherApp";
    DeleteReasonID[DeleteReasonID["TooExpensive"] = 4] = "TooExpensive";
    DeleteReasonID[DeleteReasonID["DontTrust"] = 5] = "DontTrust";
    DeleteReasonID[DeleteReasonID["BankDoesTheSame"] = 6] = "BankDoesTheSame";
    DeleteReasonID[DeleteReasonID["DontSupportAccounts"] = 7] = "DontSupportAccounts";
    DeleteReasonID[DeleteReasonID["WantAFreshStart"] = 8] = "WantAFreshStart";
})(DeleteReasonID || (DeleteReasonID = {}));
export const reasonsV3 = [
    {
        id: DeleteReasonID.AppBroken,
        reason: 'The app is broken',
        icon: <IconSettings gradientKey="apricot"/>,
    },
    {
        id: DeleteReasonID.DontKnowHowToUse,
        reason: 'I don’t know how to use it',
        icon: <IconBoldQuestion gradientKey="pro"/>,
    },
    {
        id: DeleteReasonID.ItsNotWorking,
        reason: 'It’s not working for me',
        icon: <IconEyes gradientKey="darkPurple"/>,
    },
    {
        id: DeleteReasonID.UseAnotherApp,
        reason: 'I use another app',
        icon: <IconCategory gradientKey="apricot"/>,
    },
    {
        id: DeleteReasonID.TooExpensive,
        reason: 'It’s too expensive',
        icon: <IconPiggyBank gradientKey="plus"/>,
    },
    {
        id: DeleteReasonID.DontTrust,
        reason: 'I don’t trust you',
        icon: <IconHeartCrackSolid gradientKey="ultimate"/>,
    },
    {
        id: DeleteReasonID.WantAFreshStart,
        reason: 'I want a fresh start',
        icon: <IconFlag gradientKey="pro"/>,
    },
];
